<template>
  <div class="w-full">
    <vs-row vs-justify="center">
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" class="text-left px-2">
        <vs-input
          :description-text="$t(description)"
          v-model.trim="questionsByPage[index].content"
          class="w-full"
          @blur="validateUrl()"
          :label="$t(textLabel)"
          :placeholder="$t(textLabel)"
        />
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center" v-if="type === 'photo' && validateImg">
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="4" vs-sm="12" class="text-left px-2">
        <img :src="content" class="responsive card-img-top" @error="questionsByPage[index].content = ''" />
      </vs-col>
    </vs-row>
  </div>
</template>

<script type="text/javascript">
import { mapState } from "vuex";
export default {
  props: ["index"],
  data() {
    return {
      validateImg: false
    };
  },
  methods: {
    /**
     * Valida la estructura del url
     */
    validateUrl() {
      var pattern = new RegExp(/^(https)\:\/\/[a-z0-9\.-]+\.[a-z]{2,4}/gi);
      const _url = this.questionsByPage[this.index].content;

      if (!!!pattern.test(_url)) {
        this.questionsByPage[this.index].content = "";
        this.$vs.notify({
          title: "Danger",
          text: "No es una url válida.",
          color: "danger",
          position: "top-right"
        });
        this.validateImg = false;
        return;
      } else {
        const url = new URL(_url);
        if (!(url.protocol === "https:")) {
          this.questionsByPage[this.index].content = "";
          this.$vs.notify({
            title: "Danger",
            text: "La url debe contener protocolo de seguridad https.",
            color: "danger",
            position: "top-right"
          });
          this.validateImg = false;
          return;
        }
      }
      this.validateImg = true;
    }
  },
  computed: {
    ...mapState("resource", ["questionsByPage"]),
    /**
     * Obitne el content de la propiedad del componente el cual almacena la url
     */
    content() {
      return this.questionsByPage[this.index].content;
    },
    /**
     * Obtiene la descripción para uso informativo del usaurio.
     */
    description() {
      if (this.type === "video") return "MODULE.video.subtitle";
      return "MODULE.image.subtitle";
    },
    /**
     * Obitne el tipo de componente.
     */
    type() {
      return this.questionsByPage[this.index].type;
    },
    /**
     * Otiene un título para uso informactivo del componente para el usuario.
     */
    textLabel() {
      if (this.type === "video") return "MODULE.video.label";
      return "MODULE.image.label";
    }
  }
};
</script>
